import { render, staticRenderFns } from "./maskPop.vue?vue&type=template&id=2ac09a48&lang=true&"
import script from "./maskPop.vue?vue&type=script&lang=js&"
export * from "./maskPop.vue?vue&type=script&lang=js&"
import style0 from "./maskPop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports